export const getLoadPercentageColorClass = (value: number): string => {
  if (value >= 80) {
    return 'text-status-error';
  }
  if (value >= 60) {
    return 'text-status-warning';
  }
  return '';
};
